// types
import { AdditionalSelectors, Dealership } from '@makemydeal/dr-activities-change-vehicle';
import { getOpenDealSelectors } from '../open-deal-dashboard/config';
import { getServicesBff } from '../../selectors/openDealAppSelectors';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export const additionalSelectors: AdditionalSelectors = {
    getCommonOrgId: (state) => getOpenDealSelectors()?.getCommonOrgId(state) || '',
    getDealerName: (state) => {
        const dealers = getOpenDealSelectors()?.getDealers(state);
        return dealers?.[0]?.name;
    },
    getServicesBff,
    getVehicleVin: (state) => getOpenDealSelectors()?.getVehicle(state)?.vin,
    getVehicleStockNumber: (state) => getOpenDealSelectors()?.getVehicle(state)?.stockNumber,
    getInitialPageSize: () => 5,
    getDealerships: (state): Dealership[] | undefined => {
        const isCrossDealershipAISearchEnabled = featureToggleSelectors.isEnableCrossDealershipAIVehicleSearchOD(state);
        if (!isCrossDealershipAISearchEnabled) {
            return undefined;
        }
        return getOpenDealSelectors()?.getDealerships(state);
    },
    isEnableCrossDealershipAIVehicleSearch: featureToggleSelectors.isEnableCrossDealershipAIVehicleSearchOD,
    isPromptOptimizationEnabled: featureToggleSelectors.enablePromptOptimization,
    // AVO (section + Add New Scenario) is Manager View-only. Pin false explicitly so the host-scope
    // decision is visible here and survives F291824 toggle removal — do not rely on omission.
    isAiAltVehicleOptionsActive: () => false,
    isAiAltVehicleOptionsSectionVisible: () => false,
    // No scoped store outside Manager View, so a scenario cannot be created here.
    canCreateScenario: () => false
};
